import React, { createContext, useContext, useState } from 'react';

type ModalType = 'regras' | 'grupo' | 'organizar_grupos' | 'republicar_grupos' | null;

interface IGrupoContext {
    abrirModalGrupo: (type: ModalType, data?: any) => void;
    fecharModalGrupo: () => void;

    modalType: ModalType;
    editingData: any;

    isRegraOpen: boolean;
    isGrupoOpen: boolean;
    isOrganizarOpen: boolean;
    isRepublicarOpen: boolean;
}

const GrupoContext = createContext<IGrupoContext | null>(null);

export const GrupoProvider = ({ children }: { children: React.ReactNode }) => {
    const [modalType, setModalType] = useState<ModalType>(null);
    const [editingData, setEditingData] = useState(null);

    const abrirModalGrupo = (type: ModalType, data = null) => {
        setEditingData(data);
        setModalType(type);
    };

    const fecharModalGrupo = () => {
        setModalType(null);
        setEditingData(null);
    };

    return (
        <GrupoContext.Provider
            value={{
                abrirModalGrupo,
                fecharModalGrupo,
                modalType,
                editingData,
                isRegraOpen: modalType === 'regras',
                isGrupoOpen: modalType === 'grupo',
                isOrganizarOpen: modalType === 'organizar_grupos',
                isRepublicarOpen: modalType === 'republicar_grupos',
            }}
        >
            {children}
        </GrupoContext.Provider>
    );
};

export const useGrupoContext = () => {
    const context = useContext(GrupoContext);
    if (!context) {
        throw new Error("useGrupoContext deve ser usado dentro de um GrupoProvider");
    }
    return context;
};
